import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsZoom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowsZoom"><Path d="M10.5303 14.5303L6.56055 18.5H10V20H4V14H5.5V17.4395L9.46973 13.4697L10.5303 14.5303Z" fill="currentColor"/><Path d="M18.5 17.4395V14H20V20H14V18.5H17.4395L13.4697 14.5303L14.5303 13.4697L18.5 17.4395Z" fill="currentColor"/><Path d="M10 5.5H6.56055L10.5303 9.46973L9.46973 10.5303L5.5 6.56055V10H4V4H10V5.5Z" fill="currentColor"/><Path d="M20 10H18.5V6.56055L14.5303 10.5303L13.4697 9.46973L17.4395 5.5H14V4H20V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsZoom;
